import { Component, OnInit, Input } from '@angular/core';
import { AuditTemplateModuleDetailsModel } from '../../models/audit-template-module-details.model';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { Result } from 'app/core/models/result';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AuditModuleReorderModel } from '../../models/audit-module-reorder.model';

@Component({
  selector: 'app-audit-template-modules-list',
  templateUrl: './audit-template-modules-list.component.html',
  styleUrls: ['./audit-template-modules-list.component.css']
})
export class AuditTemplateModulesListComponent implements OnInit {
    @Input() auditTemplateId: string;
    selectedModuleId: string;
    errors: string[];
    auditTemplateModules: AuditTemplateModuleDetailsModel[];

    constructor(
        private auditTemplateService: AuditTemplateService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.auditTemplateService.getAuditTemplateModules(this.auditTemplateId).subscribe(
            result => {
                this.auditTemplateModules = result.sort((a, b) => a.zOrder - b.zOrder);
            },
            error => this.errors = error.errorList
        );
    }

    deleteAuditTemplateModules(): void {
        this.auditTemplateService.deleteAuditTemplateModule(this.auditTemplateId, this.selectedModuleId).subscribe(
            result => this.load(),
            error => this.errors = (<Result>error).errorList
        );
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.auditTemplateModules, event.previousIndex, event.currentIndex);

        let model = new AuditModuleReorderModel();
        var i;
        for (i = 0; i < this.auditTemplateModules.length; i++) {
            model.auditTemplateId = this.auditTemplateModules[i].auditTemplateId;
            model.moduleId = this.auditTemplateModules[i].moduleId;
            model.zOrder = i + 1;
            this.auditTemplateService.reorderModuleQuestionBank(model).subscribe(
                () => { },
                error => this.errors = (<Result>error).errorList
            );
        }
    }

}
